/**
 * --------------------------------------------------
 * Modal Module
 *
 * @module Modal
 * --------------------------------------------------
 */

import gsap from 'gsap';

export default {
    $canvas: '.rt-js-canvas',
    $animElems: '.rt-js-anim-elem',
    $prePanel: '.rt-js-pre-panel',
    $form: '.rt-js-marketo-form',
    $canvasElem: null,
    $formElem: null,
    $modal: null,
    _selectedClass: 'selected',
    _cardsClicked: false,
    isMobile: false,
    isTablet: false,

  init: function () {
    const _self = this;
    this.$formElem = this.$form;

    // Validate viewports
    this.isMobile = window.matchMedia('(max-width: 833px)').matches;
    this.isTablet = window.matchMedia('(min-width: 834px) and (max-width: 1023px)').matches;


    // Open modal
    $('.rt-js-modal-trigger').on('click', function (e) {
        e.preventDefault();
        const targetId = $(this).data('target');
        _self.$modal = $('#' + targetId);
        const $modal = _self.$modal;
        _self.$canvasElem = _self.$modal.find('.rt-js-canvas');

        if ($modal.length) {
            $modal.addClass('is-active');
        }

        // Start initial animation
        if(!_self._cardsClicked){
            _self._animateCards();
        }
    });

    // Close modal (click on background or close button)
    $('.modal .modal-background, .modal .modal-close, .rt-js-modal-close').on('click', function () {
        const $modal = $(this).closest('.modal');
            if ($modal.length) {
                $modal.removeClass('is-active');
            }
        });
        // Close modal on Escape key
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $('.modal.is-active').removeClass('is-active');
            }
        });

        // Add listeners for starting animations when modal is opened
        this._addListeners();
    },

    // Add listeners to modal elements
    _addListeners: function () {
        const _self = this;

        this.canvasEl = document.querySelector(this.$canvas);
        if (!this.canvasEl) return;

        this.animElems = Array.from(this.canvasEl.querySelectorAll(this.$animElems));

        this.animElems.forEach((card, index) => {
            card.addEventListener('click', (e) => {
                _self._handleCardClick(e.currentTarget, index, _self.canvasEl, _self.animElems);
            }, { once: true });
        });
    },

    _animateCards: function() {
        const _self = this;
        const cardElems = this.canvasEl.querySelectorAll(this.$animElems);
        const tl = gsap.timeline({ defaults: { duration: 0.5, ease: 'back.in', overwrite: 'auto' } });

        // Animate stuff
        tl.to(cardElems, {
            opacity: 1,
            y: 20,
            stagger: {
                from: "left",
                amount: 0.3
            }
        }, 0);
    },

    // Handle click on card
    _handleCardClick: function(card, index, canvasEl, animElems) {
        const delta = this._calcDeltaX(card, canvasEl);
        const others = animElems.filter((n) => n !== card);

        const tl = gsap.timeline({ defaults: { duration: 0.5, ease: 'back.in', overwrite: 'auto' } });

        this._cardsClicked = true;

        // Add selected class to card
        card.classList.add(this._selectedClass);

        // Animate more stuff
        this._animateOthers(tl, others, index);
        this._animateClickedCard(tl, card, delta, index);

        // Feed it!
        this._feedPanel(card, index);
    },

    // Calculate initial X for card
    _calcDeltaX: function(card, canvasEl) {
        const canvasRect = canvasEl.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const canvasStyle = window.getComputedStyle(canvasEl);
        const canvasPaddingLeft = parseFloat(canvasStyle.paddingLeft) || 0;
        return (canvasRect.left + canvasPaddingLeft) - cardRect.left;
    },

    // calculate vertical translation needed to move card to top of canvas/modal
    _calcDeltaY: function(card, canvasEl) {
        if (!card || !canvasEl) return 0;
        const canvasRect = canvasEl.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();

        // consider canvas padding-top if you want a small offset
        const canvasStyle = window.getComputedStyle(canvasEl);
        const canvasPaddingTop = parseFloat(canvasStyle.paddingTop) || 0;

        // delta in viewport coords (positive => move down, negative => move up)
        // we want card to move so its top === canvas top + paddingTop
        return (canvasRect.top + canvasPaddingTop) - cardRect.top;
    },

    // Animate other cards rather than the clicked one
    _animateOthers: function(tl, others, index) {
        const _self = this;

        tl.to(others, {
            opacity: 0,
            y: -20,
            stagger: {
                from: index,
                amount: 0.2
            },
            onComplete: function() {
                others.forEach((el) => el.classList.add('hidden'));
            }
        });
    },

    // Animate clicked card
    _animateClickedCard: function(tl, card, deltaX, index) {
        const _self = this;
        const $form = _self.$modal.find(_self.$form);
        const canvasEl = _self.canvasEl;
        let tweenProps = {};

        // Calculate vertical delta for mobile (distance to canvas top / modal top)
        const deltaY = this._calcDeltaY(card, canvasEl);

        // Validate if index is 2 (show form)
        if(index === 2){
            tl.to(card, {
                y: -20,
                opacity: 0,
                ease: 'back.in',
                onComplete: function() {
                    _self._animatePanel($form[0], index, card);
                }
            });
        } else {
            tweenProps = {
                x: _self.isMobile ? 0 : deltaX,
                delay: -0.25,
                duration: 0.5,
                ease: 'back.in',
                onComplete: function() {
                    _self._animatePanel(_self.canvasEl.querySelector(_self.$prePanel), index, card);
                }
            };
        }

        // only include Y when on mobile
        if (_self.isMobile) {
            tweenProps.y = deltaY;
        }

        // Assign animation
        tl.to(card, tweenProps);
    },

    // Animate info panel
    _animatePanel: function(panel, index, card) {
        const _self = this;
        const tl = gsap.timeline({ defaults: { duration: 0.7, ease: 'power2.out' } });
        
        // Start panel animation
        tl.to(panel, {
            opacity: 1,
            duration: 0.6,
            delay: 0.2,
            y: _self.isMobile && index !== 2 ? 150 : 0,
        })
        .from(panel, {
            y: 20,
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
            onComplete: function() {
                panel.classList.remove('hidden');
                if(index === 2) {
                    // remove style added by gsap
                    panel.parentElement.removeAttribute('style');
                }
            },
            // Validate if panel if marketo form to adjust height
            onStart: function() {
                // Hide card on tablet
                if (_self.isTablet) {
                    gsap.to(card, {
                        opacity: 0,
                        duration: 0.2,
                        x: 10,
                        ease: 'power2.out',

                        onComplete: function() {
                            card.classList.add('hidden');
                        }
                    });
                }
                // Animate parent height for mobile or form (index 2)
                if (_self.isMobile || index === 2) {
                    gsap.to(panel.parentElement, {
                        height: panel.offsetHeight + 140,
                        duration: 0.4,
                        ease: 'power2.out',
                        
                        onComplete: function() {
                            if(index === 2){
                                // Form-specific: activate panel and hide canvas
                                panel.classList.add('active');
                                _self.$canvasElem[0].classList.add('hidden');
                            }
                        }
                    });
                }
            }
        }, 0);
    },

    // Feed the panel
    _feedPanel: function(card, index) {

        // Get data attributes
        const $card = $(card);
        const subheading = $card.data('subheading') || '';
        const copy = $card.data('copy') || '';
        const link = $card.data('link') || '';
        const target = $card.data('link-target') || '_self';
        const label = $card.data('link-label') || '';

        // Find panel elements
        const $panel = $card.closest(this.$canvas).find(this.$prePanel);
        const $subheadingEl = (index === 2) ? this.$modal.find('.rt-js-modal-heading') : $panel.find('.rt-js-panel-heading');
        const $copyEl = $panel.find('.rt-js-panel-copy');
        const $linkEl = $panel.find('.rt-js-panel-link');

        // Update panel content
        $subheadingEl.text(subheading);

        // If form is chosen stop feeding
        if(index === 2) return;

        // Update other content
        $copyEl.html(copy);
        if (link) {
            $linkEl.attr('href', link).attr('target', target).show();
            $linkEl.text(label);
        } else {
            $linkEl.hide();
        }
    }
};
